const ACCESS_TOKEN_KEY = "avizo.accessToken";
const REFRESH_TOKEN_KEY = "avizo.refreshToken";
const USER_ID_KEY = "avizo.userId";

const SESSION_KEY = "avizo.session";

export interface TokenPair {
  accessToken: string;
  refreshToken: string;
}

export interface StoredSession {
  userId: string;
  fullName: string;
  email: string | null;
  role: string;
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getStoredUserId(): string | null {
  return localStorage.getItem(USER_ID_KEY);
}

export function getStoredSession(): StoredSession | null {
  const userId = getStoredUserId();
  const raw = localStorage.getItem(SESSION_KEY) || sessionStorage.getItem(SESSION_KEY);
  if (!userId || !raw) return null;
  try {
    return JSON.parse(raw) as StoredSession;
  } catch {
    return null;
  }
}

export function getStoredUserRole(): string | null {
  return getStoredSession()?.role ?? null;
}

export function setTokens({ accessToken, refreshToken }: TokenPair): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

export function setStoredUserId(userId: string): void {
  localStorage.setItem(USER_ID_KEY, userId);
}

export function setStoredSession(session: StoredSession): void {
  setStoredUserId(session.userId);
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearAuthStorage(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem(SESSION_KEY);
}

